import { Component } from '@angular/core';

@Component({
  selector: 'app-healthcare-process',
  imports: [],
  templateUrl: './healthcare-process.html',
  styleUrl: './healthcare-process.scss'
})
export class HealthCareProcess {

}
